<div class="container">
  <img src="/assets/images/verify-email.svg" alt />
  <br />
  <h1>Email Verification</h1>
  We have sent you an email containing instructions on how to verify your email
  address and complete your registration. Please check your email and follow our
  instructions. If you cannot find our email, please make sure to check your
  spam folder as well.
  <br />
  <br />
  <button
    class="btn btn-primary btn-lg"
    [disabled]="state !== 'CanSend'"
    (click)="resend()">
    Resend Verification Email
  </button>
  <br />
  <br />
  <br />
  <br />
</div>
